import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import { isCompleteFilterUrl } from "~/utils/catalog/filterUrl";
import { splitGifts } from "~/utils/cartGifts";
import { getBacket } from "../../../redux/action-creaters/basket";
import styles from "./index.module.scss";
import Icon from "/components/common/icon";
import { ApiClient } from "/api/client";
import Loader from "../loader";
import { formatPrice, getPictureById } from "../../../utils";
import { showPopup } from "../../../redux/action-creaters/popup";
import { popupTypes } from "../../../redux/reducers/popupReducer";
import { ECOMMERCE_LISTS, useEcommerce } from "../../../utils/tracking";

export default function BasketItems() {
  const dispatch = useDispatch();
  const { basket, isBasketLoading } = useSelector((state) => state.cart);

  const [deletingId, setDeletingId] = useState(0);
  const [changingId, setChangingId] = useState(0);
  const { trackBasketAdd, trackBasketRemove } = useEcommerce();
  const isLoading = isBasketLoading && !basket?.ITEMS;

  useEffect(() => {
    if (!isBasketLoading && !basket?.ITEMS) {
      dispatch(showPopup(popupTypes.none));
    }
  }, [isBasketLoading, basket]);

  return (
    <div className={styles.Items}>
      {isLoading && (
        <div className={styles.Loader}>
          <Loader />
        </div>
      )}
      {!isLoading && (
        <>
          {/* Подарок к заказу выводится отдельным блоком (CartGift). */}
          {splitGifts(basket).items.map((item) => (
            <div className={styles.Item} key={item.ID}>
              <div className={styles.Photo}>
                <Link href={item.PRODUCT_DATA?.URL ?? "/"}>
                  <a>
                    <img
                      src={getPictureById(item.PRODUCT_DATA?.PICTURE_ID)?.small}
                      alt={item.PRODUCT_DATA?.NAME}
                    ></img>
                  </a>
                </Link>
              </div>
              <div className={styles.Other}>
                <div className={styles.Name}>
                  <Link href={item.PRODUCT_DATA?.URL ?? "/"}>
                    <a>{item.PRODUCT_DATA?.NAME}</a>
                  </Link>
                  {item.DISCOUNT_PRICE > 0 && (
                    <div className={styles.PriceMobileOld}>
                      {item.NO_DISCOUNT_PRICE_TOTAL} руб
                    </div>
                  )}
                  <div className={styles.PriceMobile}>
                    {item.PRICE_TOTAL} руб
                  </div>
                  {item.PRODUCT_DATA?.ELECTRIC === "нет" &&
                    isCompleteFilterUrl(item.PRODUCT_DATA?.FILTER_URL) && (
                      <a
                        className={styles.Electric}
                        href={`/catalog/elektrika_farkopov/filter/${item.PRODUCT_DATA?.FILTER_URL}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        Подобрать электрику
                      </a>
                    )}
                </div>
                <div className={styles.Qty}>
                  <div
                    onClick={async () => {
                      setChangingId(item.ID);
                      await ApiClient.basket.changeBasketQty({
                        id: item.PRODUCT_ID,
                        qty: item.QUANTITY - 1,
                      });
                      await dispatch(getBacket(true));
                      setChangingId(0);

                      trackBasketRemove(item, {
                        quantity: 1,
                        list: ECOMMERCE_LISTS.cartPopup,
                      });
                    }}
                  >
                    <Icon id="minus" width={22} height={2} />
                  </div>
                  <span>
                    {changingId && changingId === item.ID ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 50 50"
                      >
                        <path
                          fill="#333"
                          d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z"
                        >
                          <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="0.5s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    ) : (
                      item.QUANTITY
                    )}
                  </span>
                  <div
                    onClick={async () => {
                      setChangingId(item.ID);
                      await ApiClient.basket.changeBasketQty({
                        id: item.PRODUCT_ID,
                        qty: item.QUANTITY + 1,
                      });
                      await dispatch(getBacket(true));
                      setChangingId(0);

                      trackBasketAdd(item, {
                        quantity: 1,
                        list: ECOMMERCE_LISTS.cartPopup,
                      });
                    }}
                  >
                    <Icon id="plus" width={22} height={22} />
                  </div>
                </div>

                <div className={styles.Price}>
                  {item.DISCOUNT_PRICE > 0 && (
                    <div className={styles.PriceOld}>
                      {item.NO_DISCOUNT_PRICE_TOTAL} руб
                    </div>
                  )}
                  {formatPrice(item.PRICE_TOTAL)} руб
                </div>
              </div>
              <div
                className={styles.Delete}
                onClick={async () => {
                  if (deletingId) return;
                  setDeletingId(item.ID);
                  await ApiClient.basket.removeFromBasket(item.ID);
                  await dispatch(getBacket(true));
                  setDeletingId(0);

                  trackBasketRemove(item, { list: ECOMMERCE_LISTS.cartPopup });
                }}
              >
                {deletingId && deletingId === item.ID ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 50 50"
                  >
                    <path
                      fill="#333"
                      d="M25,5A20.14,20.14,0,0,1,45,22.88a2.51,2.51,0,0,0,2.49,2.26h0A2.52,2.52,0,0,0,50,22.33a25.14,25.14,0,0,0-50,0,2.52,2.52,0,0,0,2.5,2.81h0A2.51,2.51,0,0,0,5,22.88,20.14,20.14,0,0,1,25,5Z"
                    >
                      <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="0.5s"
                        repeatCount="indefinite"
                      />
                    </path>
                  </svg>
                ) : (
                  <Icon id="trash" fill={"#8d8d8d"} width={20} height={20} />
                )}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
